import { useQuery } from "@tanstack/react-query";
import { oneOnboardingApi } from "libs/api";
import { useParams } from "router";
import { useDynamicLocation } from "../commons/hooks/useDynamicLocation";
import { TanstackQueryKey } from "../commons/tanstackQueryKey";
import { useMetadataAtomState } from "./metadataAtom";

export const useMetadataApi = () => {
    const { lang, propertyId } = useParams("/:lang/list-my-property/onboard/:propertyId");
    const { pathname } = useDynamicLocation();
    const [metadata, setMetadata] = useMetadataAtomState();
    const { isFetching, isError, refetch } = useQuery({
        queryKey: [TanstackQueryKey.GetMetadata, lang],
        queryFn: () => oneOnboardingApi.getMetadata(lang, pathname, Number(propertyId)).then((res) => res.data),
        onSuccess: (metadata) => setMetadata(metadata),
    });

    return {
        data: metadata,
        isLoading: isFetching,
        isError,
        refetch,
    };
};
